<div style="padding: 28px;height:100%" class="statistics_main" fxLayout="column">
    <mat-tab-group mat-align-tabs="start" style="width:100%;height:100%">
        <mat-tab>
            <ng-template mat-tab-label>Property Market Analysis </ng-template>
            <ng-template matTabContent>
                <iframe (load)="isLoading=false" [class.is-loading]="isLoading"
                        title="Property Market Analysis" width="100%" height="100%"
                        src=" https://www.yephome.com.au/property-market-analysis"
                        frameborder="0"
                        allowFullScreen="true"></iframe>
            </ng-template>
        </mat-tab>

<!--        <mat-tab>-->
<!--            <ng-template mat-tab-label>Auction Results</ng-template>-->
<!--            <ng-template matTabContent>-->
<!--                <iframe (load)="isLoading=false" [class.is-loading]="isLoading"-->
<!--                        title="Auction Results" width="100%" height="100%"-->
<!--                        src="https://www.yephome.com.au/auction-results"-->
<!--                        frameborder="0"-->
<!--                        allowFullScreen="true"></iframe>-->
<!--            </ng-template>-->
<!--        </mat-tab>-->

        <mat-tab>
            <ng-template mat-tab-label>Market Trend and Market Forecast</ng-template>
            <ng-template matTabContent>
                <iframe (load)="isLoading=false" [class.is-loading]="isLoading"
                        title="Auction Results" width="100%" height="100%"
                        src="https://www.yephome.com.au/property-price-estimates"
                        frameborder="0"
                        allowFullScreen="true"></iframe>
            </ng-template>
        </mat-tab>
    </mat-tab-group>

    <!-- <mat-tab-group mat-align-tabs="start" style="width:100%;height:100%">
        <mat-tab>
            <ng-template mat-tab-label>Industry Statistics</ng-template>
            <ng-template matTabContent>
                <iframe (load)="isLoading=false" [class.is-loading]="isLoading"
                        title="Domain data visulization - OverView" width="100%" height="100%"
                        src="https://app.powerbi.com/view?r=eyJrIjoiZWI5ZmNjYzctYWExMC00ODFhLWIwMTYtN2QyNjgwZmM3MzE2IiwidCI6IjUyMGNjODBkLWY1NTUtNDc2ZS1iNDc2LTEwNzEwY2YxNTRjMSJ9"
                        frameborder="0"
                        allowFullScreen="true"></iframe>
            </ng-template>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>Auction Rate</ng-template>
            <ng-template matTabContent>
                <iframe (load)="isLoading=false" [class.is-loading]="isLoading"
                        title="Yephome Auction Rate - Private Share" width="100%" height="100%"
                        src="https://app.powerbi.com/view?r=eyJrIjoiMTQ4Y2FhOTUtYjkyOS00NDM3LTgwYWUtZjdhMTYzMWZiZjQ0IiwidCI6IjUyMGNjODBkLWY1NTUtNDc2ZS1iNDc2LTEwNzEwY2YxNTRjMSJ9"
                        frameborder="0"
                        allowFullScreen="true"></iframe>
            </ng-template>
        </mat-tab>
    </mat-tab-group> -->

     <app-loading *ngIf="isLoading"></app-loading>
</div>
